import { IApiClientOptions } from 'core';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import { IDeleteUploadedFileResponse, IGetUploadedFilesResponse, IUploadFileRequest, IUploadFileResponse } from 'dto/upload-file.dto';
const rootPathName = 'upload-files';

export class UploadFilesApiClient extends AssureBaseApiClient {
    constructor(options: IApiClientOptions) {
        super('uploadFiles', options);
    }

    protected getRootPath(): string {
        return rootPathName;
    }

    public async uploadFile(accountId: number, params: IUploadFileRequest, file: File): Promise<IUploadFileResponse> {
        return this.send<IUploadFileResponse>(HTTP_METHOD.POST,
            this.getRequestOptionsWithAccountId(accountId, ``, { ...params, file }));
    }

    public async getUploadedFiles(accountId: number, query): Promise<IGetUploadedFilesResponse> {
        return this.send<IGetUploadedFilesResponse>(HTTP_METHOD.GET, this.getRequestOptionsWithAccountId(accountId, '', this._convertToValidQuery(query)));
    }

    public async deleteUploadedFile(accountId: number, uuid: string): Promise<IDeleteUploadedFileResponse> {
        return this.send<IDeleteUploadedFileResponse>(HTTP_METHOD.DELETE, this.getRequestOptionsWithAccountId(accountId, uuid));
    }
}
